var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLedger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 38,
    viewBox: "0 0 37 38",
    width: 37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.08203 24.3446v7.6214h11.59777v-1.6902h-9.90795v-5.9312zm29.14357 0v5.9312h-9.908v1.6898h11.5978v-7.621zm-17.529-11.5982v11.5978h7.621v-1.5243h-5.9312v-10.0735zm-11.61457-7.6214v7.6214h1.68982v-5.93158h9.90795v-1.68982zm19.23557 0v1.68982h9.908v5.93158h1.6898v-7.6214z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLedger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ledger.c156028d63e6f565c71972598296ceb3.svg";